import { render, staticRenderFns } from "./empty-permissions-page.vue?vue&type=template&id=7257e77e&scoped=true&"
import script from "./empty-permissions-page.vue?vue&type=script&lang=js&"
export * from "./empty-permissions-page.vue?vue&type=script&lang=js&"
import style0 from "./empty-permissions-page.vue?vue&type=style&index=0&id=7257e77e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7257e77e",
  null
  
)

export default component.exports